"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const yup = __importStar(require("yup"));
const input_1 = require("./input");
// User
exports.currentUser = yup.object({});
// Conversation
exports.getConversation = yup.object({
    id: input_1.id.required(),
});
exports.getConversations = yup.object({
    limit: yup.number(),
    offset: yup.number(),
    status: yup.array(input_1.conversationStatus),
});
// Message
exports.getMessage = yup.object({
    id: input_1.id.required(),
});
exports.getMessages = yup.object({
    conversationId: input_1.id.required(),
    limit: yup.number(),
    offset: yup.number(),
});
// Topic
exports.getPendingCases = yup.object({
    limit: yup.number(),
    offset: yup.number(),
});
// Getting Started
exports.getTopicCategories = yup.object({});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicXVlcnkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvcXVlcnkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBT0EseUNBQTBCO0FBQzFCLG1DQUE4QztBQUU5QyxPQUFPO0FBQ00sUUFBQSxXQUFXLEdBQUcsR0FBRyxDQUFDLE1BQU0sQ0FBSyxFQUFFLENBQUMsQ0FBQTtBQUU3QyxlQUFlO0FBQ0YsUUFBQSxlQUFlLEdBQUcsR0FBRyxDQUFDLE1BQU0sQ0FBMkI7SUFDaEUsRUFBRSxFQUFFLFVBQUUsQ0FBQyxRQUFRLEVBQUU7Q0FDcEIsQ0FBQyxDQUFBO0FBQ1csUUFBQSxnQkFBZ0IsR0FBRyxHQUFHLENBQUMsTUFBTSxDQUE0QjtJQUNsRSxLQUFLLEVBQUUsR0FBRyxDQUFDLE1BQU0sRUFBRTtJQUNuQixNQUFNLEVBQUUsR0FBRyxDQUFDLE1BQU0sRUFBRTtJQUNwQixNQUFNLEVBQUUsR0FBRyxDQUFDLEtBQUssQ0FBQywwQkFBa0IsQ0FBQztDQUN4QyxDQUFDLENBQUE7QUFFRixVQUFVO0FBQ0csUUFBQSxVQUFVLEdBQUcsR0FBRyxDQUFDLE1BQU0sQ0FBc0I7SUFDdEQsRUFBRSxFQUFFLFVBQUUsQ0FBQyxRQUFRLEVBQUU7Q0FDcEIsQ0FBQyxDQUFBO0FBQ1csUUFBQSxXQUFXLEdBQUcsR0FBRyxDQUFDLE1BQU0sQ0FBdUI7SUFDeEQsY0FBYyxFQUFFLFVBQUUsQ0FBQyxRQUFRLEVBQUU7SUFDN0IsS0FBSyxFQUFFLEdBQUcsQ0FBQyxNQUFNLEVBQUU7SUFDbkIsTUFBTSxFQUFFLEdBQUcsQ0FBQyxNQUFNLEVBQUU7Q0FDdkIsQ0FBQyxDQUFBO0FBRUYsUUFBUTtBQUNLLFFBQUEsZUFBZSxHQUFHLEdBQUcsQ0FBQyxNQUFNLENBQTJCO0lBQ2hFLEtBQUssRUFBRSxHQUFHLENBQUMsTUFBTSxFQUFFO0lBQ25CLE1BQU0sRUFBRSxHQUFHLENBQUMsTUFBTSxFQUFFO0NBQ3ZCLENBQUMsQ0FBQTtBQUVGLGtCQUFrQjtBQUNMLFFBQUEsa0JBQWtCLEdBQUcsR0FBRyxDQUFDLE1BQU0sQ0FBSyxFQUFFLENBQUMsQ0FBQSJ9